import React from 'react'
import { Field, reduxForm, formValueSelector, change } from 'redux-form'
import { connect } from 'react-redux'
import Snackbar from '@material-ui/core/Snackbar'
import MenuItem from '@material-ui/core/MenuItem'
import CountrySelect from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'

import Input from '../shared/Input'
import Select from '../shared/Select'
import Date from '../shared/Date'
import MaskedInput from '../shared/Masked'
import * as normalizers from '../../utils/normalizers'
import * as validators from '../../utils/validators'
import { Span } from './styles/EditUserForm.style'

const zipcodeUrl = zipcode => `https://viacep.com.br/ws/${zipcode}/json/`

const Form = props => {
  const [open, setOpen] = React.useState(false)
  const [country, setCountry] = React.useState('')
  const [snackbarMessage, setSnackbarMessage] = React.useState('')
  const { error, handleSubmit, onSubmit, initialValues, zipcode, change, translation, lang } = props
  let fields = ['name', 'email', 'birthday', 'fractal_id', 'taxpayer_number', 'genre', 'phone', 'address']
  const addressArray = [
    'zipcode',
    'street',
    'number',
    'complement',
    'neighborhood',
    'city',
    'state'
  ]
  let inputComponent = { Input, Select, Date, MaskedInput }
  const required = lang === 'pt-BR' ? validators.requiredPT : validators.requiredES
  const phoneValidation = country === 'BRA' ? validators.phoneValidationBR : validators.phoneValidationPAR
  const normalizePhone = country === 'BRA' ? normalizers.normalizePhoneBRA : normalizers.normalizePhonePAR
  const options = {
    name: {
      type: 'text',
      name: 'name',
      label: `${translation('editUserForm')['nameLabel']}:`,
      disabled: false,
      component: 'Input',
      validate: [required]
    },
    email: {
      type: 'text',
      name: 'email',
      label: `${translation('editUserForm')['emailLabel']}:`,
      disabled: true,
      component: 'Input'
    },
    birthday: {
      type: 'date',
      name: 'birthday',
      label: `${translation('editUserForm')['birthdayLabel']}:`,
      disabled: false,
      component: 'Date',
      validate: [required]
    },
    phone: {
      type: 'text',
      name: 'phone',
      label: `${translation('editUserForm')['phoneLabel']}:`,
      disabled: false,
      component: 'MaskedInput',
      normalize: normalizePhone,
      validate: [required, phoneValidation],
      numberFormat: country === 'BRA' ? '(##) #####-####' : country === 'PAR' ? '##########' : '',
      prefix: translation('editUserForm')['phonePrefix']
    },
    taxpayer_number: {
      type: 'text',
      name: 'taxpayer_number',
      label: country === 'BRA' ? 'CPF' : 'CI',
      disabled: !!initialValues.taxpayer_number,
      component: 'MaskedInput',
      normalize: normalizers.normalizeTaxPayer,
      validate: [required, validators.taxpayerValidation],
      numberFormat: country === 'BRA' ? '###.###.###-##' : country === 'PAR' ? '#######' : ''

    },
    genre: {
      type: 'select',
      name: 'genre',
      label: `${translation('editUserForm')['genreLabel']}:`,
      disabled: false,
      component: 'Select',
      options: [
        { label: 'Masculino', value: 'male' },
        { label: 'Feminino', value: 'female' }
      ],
      validate: [required]
    },
    fractal_id: {
      type: 'text',
      name: 'fractal_id',
      label: 'Fractal Id',
      disabled: true,
      component: 'MaskedInput'
    },
    zipcode: {
      type: 'text',
      name: 'zipcode',
      label: `${translation('editUserForm')['zipcodeLabel']}:`,
      disabled: false,
      component: 'MaskedInput',
      numberFormat: '#####-###'
    },
    street: {
      type: 'text',
      name: 'street',
      label: `${translation('editUserForm')['streetLabel']}:`,
      disabled: false,
      component: 'Input'
    },
    number: {
      type: 'number',
      name: 'number',
      label: `${translation('editUserForm')['numberLabel']}:`,
      disabled: false,
      component: 'Input'
    },
    complement: {
      type: 'other',
      name: 'complement',
      label: `${translation('editUserForm')['complementLabel']}:`,
      disabled: false,
      component: 'Input'
    },
    neighborhood: {
      type: 'text',
      name: 'neighborhood',
      label: `${translation('editUserForm')['neighborhoodLabel']}:`,
      disabled: false,
      component: 'Input'
    },
    city: {
      type: 'text',
      name: 'city',
      label: `${translation('editUserForm')['cityLabel']}:`,
      disabled: false,
      component: 'Input'
    },
    state: {
      type: 'text',
      name: 'state',
      label: `${translation('editUserForm')['stateLabel']}:`,
      disabled: false,
      component: 'Input'
    }
  }
  const handleClose = () => {
    setOpen(false)
  }
  const searchZipcopde = () => {
    let newZipcode = zipcode?.replace(/[^0-9]/g, '')
    if (newZipcode?.length !== 8) {
      setSnackbarMessage('O cep deve possuir 8 números')
      setOpen(!open)
      return
    }
    fetch(zipcodeUrl(newZipcode))
      .then(res => res.json())
      .then(data => {
        if (data.erro) {
          setOpen(!open)
          setSnackbarMessage(`O cep ${zipcode} não foi encontrado`)
        } else {
          change('additional_data.address.street', data.logradouro)
          change('additional_data.address.neighborhood', data.bairro)
          change('additional_data.address.city', data.localidade)
          change('additional_data.address.state', data.uf)
        }
      })
      .catch(error => console.error(error))
  }
  const renderForm = fields.map((element, index) => {
    if (element === 'address') {
      return addressArray.map(address => (
        <React.Fragment key={`address[${address}]`}>
          <Field
            name={`additional_data.address.${options[address].name}`}
            type={options[address].type}
            label={options[address].label}
            placeholder={options[address].label}
            component={inputComponent[options[address].component] || options[address].component}
            options={options[address].options ? options[address].options : null}
            props={{
              disabled: options[address].disabled,
              ...options[address].mask
            }}
            normalize={options[address].normalize}
            numberFormat={options[address].numberFormat}
            validate={options[address].validate}
          />
          {
            options[address].name === 'zipcode' && country === 'BRA' &&
            <Span
              onClick={() => searchZipcopde()}
            >
              Buscar
            </Span>
          }
        </React.Fragment>
      ))
    }
    return (
      <Field
        name={options[element].name}
        key={index}
        type={options[element].type}
        label={options[element].label}
        placeholder={options[element].label}
        component={inputComponent[options[element].component] || options[element].component}
        options={options[element].options ? options[element].options : null}
        props={{
          disabled: options[element].disabled,
          ...options[element].mask,
          ...options[element].preffix
        }}
        normalize={options[element].normalize}
        numberFormat={options[element].numberFormat}
        prefix={options[element].prefix}
        validate={options[element].validate}
      />
    )
  })
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      padding: '5%',
      width: '100%'
    }}>
      { country === 'BRA' || country === 'PAR' ? (<h2>{translation('editUserForm')['personalInformation']}</h2>) : (<></>)}

      <InputLabel id='country-label'> {translation('editUserForm')['selectCountry']}  </InputLabel>
      <CountrySelect
        labelId='country-label'
        id='country'
        value={country}
        onChange={event => setCountry(event.target.value)}
      >
        {[
          {
            label: 'Brasil',
            value: 'BRA'
          },
          {
            label: 'Paraguay',
            value: 'PAR'
          }
        ].map(country => {
          return (
            <MenuItem key={country.value} value={country.value}> {country.label} </MenuItem>
          )
        })}
      </CountrySelect>
      <form initialValues={initialValues} style={{ display: 'flex', flexDirection: 'column' }} onSubmit={handleSubmit(onSubmit)}>
        {country !== '' && renderForm }
        {error && <strong>{error}</strong>}
      </form>
      <Snackbar
        open={open}
        onClose={handleClose}
        message={snackbarMessage}
      />
    </div>
  )
}

const mapStateToProps = (state, props) => {
  const selector = formValueSelector('editForm')
  const { initialValues } = props
  const initValues = {
    fractal_id: initialValues.fractal_id,
    name: initialValues.name,
    email: initialValues.email,
    genre: initialValues.genre,
    birthday: initialValues.birthday,
    phone: initialValues.phone,
    taxpayer_number: initialValues.taxpayer_number,
    additional_data: initialValues.additional_data
  }
  return {
    zipcode: selector(state, 'additional_data.address.zipcode'),
    initialValues: initValues
  }
}

const mapDispatchToProps = (dispatch) => ({
  change: (field, data) => dispatch(change('editForm', field, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'editForm'
})(Form))
